<template>
  <fiche class="fiche-container">
    <div class="height-top">
      <section class="Haut">
        <header class="Fiche__header text-moyen">
          <div class="tl block text-bold text-normal">
            {{ date }} - références
          </div>
          <div class="tc block text-bold text-normal">&nbsp;</div>
          <div class="tr block text-bold text-normal">scalene architectes</div>
        </header>
      </section>
      <section
        class="Fiche__title ProjectTextIndex__title text-ttgros"
        style="display: flex;"
        v-if="title || titlesecond"
      >
        <span
          style="margin-top: -9px;
    margin-bottom: -12px;
    display: block;
    width: calc(21cm - 36mm);"
          :style="{
            marginBottom: titlesecond ? '-12px' : '-7px',
            marginRight: format === 'A3' ? '36mm' : 0
          }"
          >{{ title }}</span
        ><span
          v-if="format === 'A3'"
          style="
        font-style: italic;
    margin-bottom: -14px;
    margin-left:auto;
    display: block;
    width: calc(21cm - 36mm);"
          >{{ titlesecond }}</span
        >
      </section>
      <div class="Fiche__header__notitle__spacer" v-else></div>
    </div>
    <div
      class="height-middle"
      style="overflow: hidden"
      :style="{ height: `${middle.height}px` }"
    >
      <div
        class="project_pictures"
        :class="`columns-${columnizedProjects.length} format-${format}`"
      >
        <div
          v-for="(column, col) in columnizedProjects"
          :key="col"
          style="height: 100%;"
        >
          <div
            class="text-small text-reg project_picture"
            v-for="(project, pindex) in column"
            :key="project.uuid"
            :class="`row-${density === 6 ? 3 : 4}`"
          >
            <image-fiche
              :id="project.main_image"
              :density="_density"
              :title="
                `${col * (density === 6 ? 3 : 4) +
                  pindex +
                  index * (density * (format === 'A4' ? 1 : 2)) +
                  1}. ${project.name}`
              "
            ></image-fiche>
          </div>
        </div>
      </div>
    </div>
    <div class="height-bottom">
      <div
        class="project_infos"
        :class="`columns-${columnizedProjects.length} format-${format}`"
      >
        <div v-for="(col, colindex) in columnizedProjects" :key="colindex">
          <div
            class="text-xsmall project_info"
            v-for="(project, pindex) in col"
            :key="pindex"
          >
            <!-- eslint-disable -->
            <span>{{(colindex * (density === 6 ? 3 : 4) + pindex) + index * (density * (format === 'A4' ? 1 : 2)) + 1}}.</span> <!-- eslint-enable --> {{ project.name }}, {{project.city}} ({{project.zipcode.slice(0,2)}}) <span class="text-light">Programme&nbsp;</span>{{ mapNames(project.programs) }} <span class="text-light" v-if="getArchitectes(project)">
              Équipe&nbsp;de&nbsp;maîtrise&nbsp;d'œuvre</span
            >&nbsp;<span class="text-reg"
              ><span v-for="(a, index) in getArchitectes(project)" :key="index"
                >{{ filterScalene(a)
                }}<span v-if="index !== getArchitectes(project).length - 1"
                  >,
                </span></span
              ></span
            >
            <span v-if="getDate(project)"
              ><span class="text-light"> Date&nbsp;</span
              >{{ getDate(project) }}</span
            >
            <span v-if="project.cost"
              ><span class="text-light"> Coût&nbsp;</span
              >{{ formatNumbersFrench(project.cost) }}€</span
            >
            <span class="text-light" v-if="project.missions.length > 0">
              {{ "Mission" | plural(project.missions) }}&nbsp;</span
            >{{ mapNames(project.missions) }}
          </div>
        </div>
      </div>
    </div>
    <span
      class="pageNumber ProjectImageIndex__pageNumber text-moyen"
      v-if="total > 1"
      >{{ index + 1 }}/{{ total }}</span
    >
  </fiche>
</template>

<script>
import Fiche from "../../../PrintComponents/Fiche/Fiche";
import {
  cheapoClone,
  dRect,
  mapNames,
  filterScalene,
  getArchitectesWithMandataireDistinction,
  formatNumbersFrench
} from "../../../../../util/func";
import _ from "lodash";
import ImageFiche from "../../../PrintComponents/Fiche/Projet/ImageFicheIndex";

export default {
  name: "FichePortraitIndex",
  components: {
    ImageFiche,
    Fiche
  },
  data() {
    return {
      top: dRect(),
      bottom: dRect(),
      middle: dRect(),
      container: dRect(),
      imageBox: dRect(),
      middleHeight: 0
    };
  },
  computed: {
    _density() {
      return parseInt(this.density, 10);
    },
    date() {
      return new Date().toLocaleDateString();
    },
    columnizedProjects() {
      const n = {
        A46: 3,
        A412: 4,
        A36: 3,
        A312: 4
      }[`${this.format}${this._density}`];
      const chunked = _.chunk(this.projects, n);
      const targetColumns = {
        A46: 2,
        A412: 3,
        A36: 4,
        A312: 6
      }[`${this.format}${this._density}`];
      while (chunked.length < targetColumns) chunked.push([]);
      return chunked;
    }
  },
  props: {
    density: {},
    format: {},
    index: {},
    projects: {},
    pm: {},
    title: {},
    titlesecond: {},
    total: {}
  },
  methods: {
    mapNames,
    filterScalene,
    formatNumbersFrench,
    getArchitectes(project) {
      return getArchitectesWithMandataireDistinction(project);
    },
    getDate(project) {
      if (project.dates_d.length === 0) return false;
      const b = project.dates_d
        .slice(0)
        .sort((b, a) => (b.content > a.content ? -1 : 1))[0];
      return b.content;
    },
    async removeDimensions() {
      this.$set(this, "top", dRect());
      this.$set(this, "bottom", dRect());
      this.$set(this, "container", dRect());
      this.$set(this, "middle", dRect());
      await new Promise(r => this.$nextTick(r));
    },
    /* eslint-disable no-cond-assign */
    getDimensions() {
      if (typeof this.$el.querySelector !== "function") return;
      let a = this.$el;
      if (a) this.container = cheapoClone(a.getBoundingClientRect());
      a = this.$el.querySelector(".height-top");
      if (a) this.top = cheapoClone(a.getBoundingClientRect());
      a = this.$el.querySelector(".height-bottom");
      if (a) this.bottom = cheapoClone(a.getBoundingClientRect());
      a = this.$el.querySelector(".project_picture div");
      if (a) this.imageBox = cheapoClone(a.getBoundingClientRect());
    },
    setMiddleDimensions() {
      this.middle.height =
        this.container.height - this.bottom.height - this.top.height;
    },
    async resetDimensions() {
      await this.removeDimensions();
      await new Promise(r => this.$nextTick(r));
      await this.getDimensions();
      await new Promise(r => this.$nextTick(r));
      this.setMiddleDimensions();
    }
  },
  async mounted() {
    await new Promise(r => this.$nextTick(r));
    this.resetDimensions();
  },
  watch: {
    pm: {
      handler() {
        this.$nextTick(this.resetDimensions);
      },
      deep: true
    },
    title(val, old) {
      if ((val === "" && old !== "") || (val !== "" && old === ""))
        this.resetDimensions();
    },
    titlesecond(val, old) {
      if ((val === "" && old !== "") || (val !== "" && old === ""))
        this.resetDimensions();
    },
    format() {
      this.resetDimensions();
    },
    density() {
      this.resetDimensions();
    }
  }
};
</script>
